module.exports = __webpack_public_path__ + "static/media/profilePicture.dfd8ec53.jpeg";